import { render, staticRenderFns } from "./FinalClubInfo.vue?vue&type=template&id=528e49ec&scoped=true"
import script from "./FinalClubInfo.vue?vue&type=script&lang=js"
export * from "./FinalClubInfo.vue?vue&type=script&lang=js"
import style0 from "./FinalClubInfo.vue?vue&type=style&index=0&id=528e49ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528e49ec",
  null
  
)

export default component.exports